export const SALE_PRICE_REQUIRED_ERROR = "El precio de venta no puede ser cero";
export const OFFER_PRICE_ERROR =
    "El precio de venta debe ser menor que el precio anterior para aplicar una oferta.";
export const COST_ABOVE_SALE_PRICE_WARNING =
    "⚠️ El precio de venta es inferior al costo del producto.";
export const COST_ABOVE_BOTH_PRICES_WARNING =
    "⚠️ El costo es mayor que el precio de venta y que el precio anterior.";

export const isOfferPrice = (price, priceOffer) =>
    priceOffer > 0 && priceOffer < price;

export const getDiscountPercent = (price, priceOffer) =>
    isOfferPrice(price, priceOffer)
        ? Math.round(100 - (priceOffer / price) * 100)
        : 0;

export const getOfferError = ({ offerActive, previousPrice, salePrice }) =>
    offerActive && salePrice >= previousPrice ? OFFER_PRICE_ERROR : "";

export const getCostWarning = ({
    cost,
    offerActive,
    previousPrice,
    salePrice
}) => {
    if (!cost) return "";
    if (offerActive && cost > previousPrice) {
        return COST_ABOVE_BOTH_PRICES_WARNING;
    }
    if (cost > salePrice) return COST_ABOVE_SALE_PRICE_WARNING;
    return "";
};
